var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280",
    transform: "translate(-9337 -268)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 12,
    height: 12,
    transform: "translate(9337 268)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M9343.1,279.324a5.333,5.333,0,1,1,5.333-5.333A5.339,5.339,0,0,1,9343.1,279.324Zm0-9.68a4.347,4.347,0,1,0,4.348,4.347A4.352,4.352,0,0,0,9343.1,269.644Zm-.693,6.218v-3.743a.493.493,0,0,0-.985,0v3.743a.493.493,0,0,0,.985,0Zm2.372,0v-3.743a.493.493,0,0,0-.985,0v3.743a.493.493,0,0,0,.985,0Z",
    fill: "#ff3056"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStop);
export default __webpack_public_path__ + "static/media/icon-stop.f208d005b2561a1378dd4c34ea557e4b.svg";
export { ForwardRef as ReactComponent };